import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'app-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingIndicatorComponent {
    public readonly styleClasses = input<string>('h-4 w-4 ');
}
